import axios from 'axios'
import { isNil } from 'lodash'

import { getEpsBaseUrl } from './eps-base-url'

export type EmployerMembership = {
  personId: string
  employeePublicKey: string
  clientPublicKey: string
  companyName: string
  isPrimary: boolean
}

export const MEMBERSHIPS_FETCH_TIMEOUT_MS = 5000

/**
 * Flag-filtered employer memberships for the Cognito-authenticated employee.
 * GET api/v1/members/me/memberships
 */
export const fetchMyMemberships = async (): Promise<EmployerMembership[]> => {
  const baseURL = getEpsBaseUrl()
  const response = await axios.get<EmployerMembership[]>(
    'api/v1/members/me/memberships',
    { baseURL }
  )
  return isNil(response.data) ? [] : response.data
}

export const buildSyntheticMembership = ({
  personId,
  clientPublicKey = '',
  companyName = '',
}: {
  personId: string
  clientPublicKey?: string
  companyName?: string
}): EmployerMembership => ({
  personId,
  employeePublicKey: personId,
  clientPublicKey: isNil(clientPublicKey) ? '' : clientPublicKey,
  companyName: isNil(companyName) ? '' : companyName,
  // Never claim home — cold-start fallback after switch would mark a secondary
  // identity as primary and unlock change-password/email.
  isPrimary: false,
})
